var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.991161 5.65626L5.64237 0.853085C5.67581 0.818664 5.72363 0.790115 5.78107 0.770277C5.83851 0.750438 5.90356 0.74 5.96977 0.74C6.03598 0.74 6.10103 0.750438 6.15847 0.770277C6.21591 0.790115 6.26373 0.818664 6.29718 0.853085L10.9484 5.65626C10.9821 5.69106 10.9999 5.73061 11.0001 5.7709C11.0003 5.81119 10.9827 5.8508 10.9493 5.88569C10.9159 5.92059 10.8677 5.94954 10.8097 5.96962C10.7517 5.98969 10.686 6.00017 10.6191 6H1.31895C1.25219 6.00001 1.18662 5.98941 1.12884 5.96927C1.07106 5.94913 1.02312 5.92016 0.989871 5.88529C0.956619 5.85043 0.939229 5.81089 0.939455 5.77067C0.939682 5.73046 0.957518 5.69099 0.991161 5.65626Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscSort);
export default __webpack_public_path__ + "static/media/asc-sort.bb3acfce069bf356aaa84630cba40554.svg";
export { ForwardRef as ReactComponent };